export default __webpack_public_path__ + "static/media/anatomy-of-a-seed@2x.e55e7b99.png";